import React, { useState, useEffect } from 'react';
import user from '../../store/user';
import './recruiterActivityList.scss';
import { Table } from 'semantic-ui-react';
import Loader from '../../components/Loader';
import CountDisplay from '../../components/CountDisplay';
import Pagination from '../../components/Pagination';
import Button from '../../components/Button';
import Heading from '../../components/Heading';
import { toast, ToastContainer } from 'react-toastify';
import fetchActivityDetails from '../../services/fetchActivityDetails';
import { getQueryParams } from "../../utils/utilFunctions";
import { getInstituteMap } from '../../models/institutes';

const PAGE_CONTENT = 50;

const RecruiterActivityList = (props) => {

  const [content, setContent] = useState({
    actionId: '',
    jobId: '',
    jobTitle: '',
    list: [],
    count: 0,
    pageNumber: 1
  })

  const [admin, setAdmin] = useState({
    adminId: null,
  })
  const [fetchApiCall, setFetchApiCall] = useState(true);

  useEffect(() => {

    const fetchProfile = async () => {
      return await user.getProfile()
    }
    fetchProfile().then(userData => {
      if (userData.adminType == 2 || userData.adminType == 3 || userData.adminType == 4) {
        setAdmin({
          adminId: userData.id,
        })
        getResult(userData.id);

      } else {
        window.location.href = process.env.REACT_APP_LOGIN_URL;
      }
    });

  }, [])

  const getDetails = async (adminId, pageNumber, filters = {}, jobTitle) => {
    setFetchApiCall(true);
    try {
      const res = await fetchActivityDetails(adminId, { pageNumber, pageContent: PAGE_CONTENT, ...filters })
      setContent(prev => ({
        ...prev,
        pageNumber: pageNumber,
        list: res.data.data.data,
        count: res.data.data.totalCount
      }))
      setFetchApiCall(false)
    }
    catch (err) {
      toast.error('Something went wrong');
      console.log(err);
      setFetchApiCall(false)
    }
  }

  const handlePageChange = async(n) => {
      const filters = {
        jobId: content.jobId,
        actionId: content.actionId
      }
      await getDetails(admin.adminId, n, filters)
      routeRequest(content.pageNumber, filters, content.jobTitle)

  }

  const routeRequest = (pageNumber, filters, jobTitle) => {
    
    let array = [];

    array.push(`pageNumber=${pageNumber}`);
    if(filters.actionId){
      array.push(`actionId=${filters.actionId}`)
    }
    if(filters.jobId){
      array.push(`jobId=${filters.jobId}`)
    }
    if(jobTitle){
      array.push(`title=${jobTitle}`)
    }
    array = array.join("&");
    props.history.push("?" + array);
};

 
  const getResult = async (adminId) => {
    const queryObj = getQueryParams(props.location.search);
    setContent(prev => ({
      ...prev,
      actionId: queryObj.actionId,
      jobId: queryObj.jobId,
      jobTitle: queryObj.title,
      pageNumber: queryObj.pageNumber
    }))
    const filterObj = {};
    if(queryObj.actionId) {
      filterObj['actionId'] = queryObj.actionId;

    }
    if(queryObj.jobId) {
      filterObj['jobId'] = queryObj.jobId;
    }
    const pgNo = queryObj.pageNumber ? queryObj.pageNumber : 1;
    await getDetails(adminId, pgNo, filterObj, queryObj.title);
  }

  const getInstitutesName = (institute) => {
    let name = getInstituteMap()[institute];

    if(name){
      return name;
    }

    return institute;
  }

  const getActivityName = (id) => {

    if(id == 4) return 'Resume Viewed';
    if(id == 5) return 'Resume/Excel Downloaded'
  }

  return (
    <div className="report-activity-list-wrapper">
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange
        draggable={false}
        pauseOnHover
      />

      <div className="report-list-heading">
        <Heading text={`${decodeURIComponent(content['jobTitle'])} - ${getActivityName(content['actionId'])}`} />
        {/* <a href={`${process.env.REACT_APP_CLIENT_URL}/recruiter/mgr_job_reports_admin2.php`} target='_blank'>
            <Button skin='dark' className="btn_use_old" disabled={false} text='Use Old Version'/>
        </a> */}
      </div>

        <hr />


      <div className="row text-center">

      <Pagination
          totalItemsCount={content.count}
          content={PAGE_CONTENT}
          pageNumber={content.pageNumber}
          handlePageChange={(n) => handlePageChange(n)} />
      <CountDisplay start={(content.pageNumber - 1) * PAGE_CONTENT + 1} end={content.pageNumber * PAGE_CONTENT} total={content.count} />

        {fetchApiCall ? (
          <Loader />
        ) : (
          content.list.length ? (
            <div className="content">
              <Table
                fixed
                selectable
                className="mailers-table"
              >
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell width={3}>
                      Name
                    </Table.HeaderCell>
                    <Table.HeaderCell width={6}>
                      Organization, Title
                    </Table.HeaderCell>
                    <Table.HeaderCell width={3}>
                      Institute
                    </Table.HeaderCell>
                    <Table.HeaderCell width={4}>
                      Experience
                    </Table.HeaderCell>
                    <Table.HeaderCell width={3}>
                      Location
                    </Table.HeaderCell>
                    <Table.HeaderCell width={3}>
                      Salary
                    </Table.HeaderCell>    
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {content.list.map((item, i) => {
                    return (
                      <Table.Row>
                        <Table.Cell>
                            {item['name']}
                        </Table.Cell>
                        <Table.Cell>
                            {`${item['current_organization']}, ${item['current_designation']}`}                        </Table.Cell>
                        <Table.Cell>
                            { `${getInstitutesName(item['institute'])}, Batch: ${item['passing_year']}`}
                        </Table.Cell>
                        <Table.Cell>
                            {`${item['exp_year']}y ${item['exp_month']}m`}
                        </Table.Cell>
                        <Table.Cell>
                            { item['current_location'] }
                        </Table.Cell>
                        <Table.Cell>
                            {item['confidential'] == 1 ? 'Confidential' : item['current_ctc']}
                        </Table.Cell>
                      </Table.Row>
                    );
                  })}
                </Table.Body>
              </Table>
            </div>
          ) : (
            <div>
              No Records Found
            </div>
          )
          
        )
        }
      </div>
    </div>
  );
};

export default RecruiterActivityList;